/**
 * Describes all 5xx error codes.
 */
export const ERROR_CODE_SERVER_ERROR_INDEX = 5;
